import { Reveal, Eyebrow } from "./Reveal";

export default function PageHeader({ eyebrow, title, sub }) {
  return (
    <section className="bg-azur pb-16 pt-36 text-sand lg:pb-20 lg:pt-44">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <Eyebrow light>{eyebrow}</Eyebrow>
          <h1 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-[1.1] tracking-tight sm:text-5xl">
            {title}
          </h1>
          {sub && (
            <p className="mt-5 max-w-2xl text-base font-light leading-relaxed text-sand/70 sm:text-lg">{sub}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
